import { render } from "./product-badges.vue?vue&type=template&id=c93e900e"
import script from "./product-badges.vue?vue&type=script&lang=js"
export * from "./product-badges.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__